import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Utils from "../../../../utils/utils";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import moment from "moment/moment";
import TableHeader from "../../../../components/TableHeader";
import Pagination from "../../../../components/Pagination";
import ModalAddPaymentCLB from "./modalAddPaymentCLB";

class ModalDetailPaymentEat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            busUserServiceRes: [],
            listData: [],
            moneyRefund:  0,
            paidMoneyRefund:  0,
            name: '',
            dateCancel:  new Date(),
            price: 0,
            priceDiscount: 0,
            status: true,
            stateService: "",
            historyHeader: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "date",
                    name: "Ngày",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "money",
                    name: "Giá",
                    style: {textAlign: "left"},
                    sort: false
                },
            ],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "date",
                    name: "Ngày",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "money",
                    name: "Tiền thanh toán",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Hình thức",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "note",
                    name: "Chú thích",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        if (nextProps.show){
            this.setState(nextProps.item, ()=>{
                this.getDetailRouteBusRegister(nextProps.item?.id)
            })
        }
    }
    updatePaymentState() {
        let payment = parseFloat(this.state.payment.toString().replaceAll(",", ""))
        let paidMoneyRefund = parseFloat(this.state.paidMoneyRefund.toString().replaceAll(",", ""))
        let discount = parseFloat(this.state.discount.toString().replaceAll(",", ""))
        let moneyRefund = parseFloat(this.state.moneyRefund.toString().replaceAll(",", ""))
        let moneyPay = parseFloat(this.state.moneyPay.toString().replaceAll(",", ""))

        let payLoad = {
            "daDong": payment,
            "daHoanTra": paidMoneyRefund,
            "discount": discount,
            "hoanTra": moneyRefund,
            "id": this.state.id,
            "phaiDong": moneyPay,
            "reasonDiscount": this.state.reasonDiscount,
            "state": this.state.stateService
        }
        BusRouteController.updateBusUserPayment(payLoad, res => {
            if (res.success) {
                toast.success("Cập nhật thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }
    getDetailRouteBusRegister(busId) {
        BusRouteController.detailRegister(busId, res => {
            if (res.success){
                if (res.data.assistant1Res != null){
                    this.setState({
                        assistant1Id: res.data.assistant1Res["officerId"],
                        assistant1Name: res.data.assistant1Res["fullName"],
                        assistant1Username: res.data.assistant1Res["username"],
                    })
                }
                if (res.data.assistant2Res != null){
                    this.setState({
                        assistant2Id: res.data.assistant2Res["officerId"],
                        assistant2Name: res.data.assistant2Res["fullName"],
                        assistant2Username: res.data.assistant2Res["username"],
                    })
                }
                if (res.data.assistant3Res != null){
                    this.setState({
                        assistant3Id: res.data.assistant3Res["officerId"],
                        assistant3Name: res.data.assistant3Res["fullName"],
                        assistant3Username: res.data.assistant3Res["username"],
                    })
                }
                let userInfo = res.data.busUserServiceRes[res.data.id-1]
                this.setState({
                    busRouteId: res.data.id,
                    name: res.data.name,
                    driverName: res.data.driverName,
                    driverPhone: res.data.driverPhone,
                    busStopRes: res.data.busStopRes,
                    busUserServiceRes: res.data.busUserServiceRes,
                    paidMoneyTotal: res.data.paidMoneyTotal,
                    paidNumber: res.data.paidNumber,
                    remainMoneyTotal: res.data.remainMoneyTotal,
                    seatNumber: res.data.seatNumber,
                    seatNumberRegistered: res.data.seatNumberRegistered,
                    totalMoney: userInfo?.busTypeRes["price"]*userInfo.priceType,
                    payment:  userInfo?.payment,
                    discount:  userInfo?.discount,
                    moneyRefund:  userInfo?.moneyRefund?userInfo?.moneyRefund: 0,
                    paidMoneyRefund:  userInfo?.paidMoneyRefund?userInfo?.paidMoneyRefund: 0,
                    moneyPay:  userInfo?.busTypeRes["price"]*userInfo.priceType-userInfo?.payment-userInfo?.discount,
                }, ()=>{
                })
            }else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }
        })
    }
    getEndDayService(starDate, month){
        let end = new Date(starDate)
        let newDate = new Date(end.setMonth(end.getMonth()+parseInt(month)));
        return moment(newDate).format("DD-MM-YYYY")
    }
    render() {
        let {listData, historyHeader, header} = this.state;
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered modal-size-large">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Chi tiết thanh toán ăn</b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                    Danh sách bữa ăn tháng 3
                                </div>
                                <div className="col-12 p-2 mb-2">
                                    <div className="p-0 mb-3">
                                        <div className="table-wrapper">
                                            <table
                                                className="table table-striped table-data table-responsive table-bordered">
                                                <table className="table">
                                                    <thead>
                                                    <TableHeader
                                                        header={historyHeader}
                                                        clickSort={data => {
                                                            let a = "";
                                                            let descend = "";
                                                            if (data.sortAsc == null) {
                                                                // a = "id=asc";
                                                                a = "id";
                                                                descend = 'DESC'
                                                            } else {
                                                                a = data.sortId;
                                                                descend = data.sortAsc ? 'ASC' : 'DESC'
                                                            }
                                                            this.setState(
                                                                {
                                                                    sort: a,
                                                                    descending: descend
                                                                },
                                                                () => this.getListCustomerPayment()
                                                            );
                                                        }}
                                                    />
                                                    </thead>
                                                    {!this.state.listData ||
                                                    this.state.listData.length == 0 ? (
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan={12}>
                                                                <div className="text-center">
                                                                    Không có dữ liệu
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                        {listData &&
                                                        listData.length > 0 &&
                                                        listData?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                    index +
                                                                    1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {this.formatMoney(row.money)} VNĐ
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.content}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.createdAt}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    )}
                                                </table>
                                            </table>
                                        </div>
                                        <div className="pagination-right">
                                            <Pagination
                                                activePage={this.state.pageNumber}
                                                itemsCountPerPage={this.state.pageSize}
                                                totalItemsCount={this.state.totalItem}
                                                changeHandler={page => this.handleChangePage(page)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                    Lịch sử giao dịch nộp tiền
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 p-0 d-flex"
                                     style={{
                                         alignItems: "center",
                                         justifyContent: "right",
                                         marginTop: "10px"
                                     }}>
                                    <button
                                        type="button"
                                        className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                        onClick={() => {
                                            this.setState({itemSelected: {
                                                    customerId: this.state.customerId,
                                                    childName: this.state.childName
                                                }, showModalCustomerPayment: true})
                                        }}
                                    >
                                        <span className='d-flex justify-content-center'>
                                            Thêm
                                        </span>
                                    </button>
                                </div>
                                <div className="col-12 p-2 mb-2">
                                    <div className="p-0 mb-3">
                                        <div className="table-wrapper">
                                            <table
                                                className="table table-striped table-data table-responsive table-bordered">
                                                <table className="table">
                                                    <thead>
                                                    <TableHeader
                                                        header={header}
                                                        clickSort={data => {
                                                            let a = "";
                                                            let descend = "";
                                                            if (data.sortAsc == null) {
                                                                // a = "id=asc";
                                                                a = "id";
                                                                descend = 'DESC'
                                                            } else {
                                                                a = data.sortId;
                                                                descend = data.sortAsc ? 'ASC' : 'DESC'
                                                            }
                                                            this.setState(
                                                                {
                                                                    sort: a,
                                                                    descending: descend
                                                                },
                                                                () => this.getListCustomerPayment()
                                                            );
                                                        }}
                                                    />
                                                    </thead>
                                                    {!this.state.listData ||
                                                    this.state.listData.length == 0 ? (
                                                        <tbody>
                                                        <tr>
                                                            <td colSpan={12}>
                                                                <div className="text-center">
                                                                    Không có dữ liệu
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                        {listData &&
                                                        listData.length > 0 &&
                                                        listData?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                    index +
                                                                    1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {this.formatMoney(row.money)} VNĐ
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.content}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.createdAt}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                        </tbody>
                                                    )}
                                                </table>
                                            </table>
                                        </div>
                                        <div className="pagination-right">
                                            <Pagination
                                                activePage={this.state.pageNumber}
                                                itemsCountPerPage={this.state.pageSize}
                                                totalItemsCount={this.state.totalItem}
                                                changeHandler={page => this.handleChangePage(page)}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <ModalAddPaymentCLB
                                    show={this.state.showModalCustomerPayment}
                                    onHide={() => this.setState({showModalCustomerPayment: false})}
                                    onRefresh={() => this.getListCustomerPayment()}
                                    info={this.state.itemSelected}
                                />
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-3 label-item pl-0">Trạng thái thanh toán</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.stateService}
                                        onChange={(e) => {
                                            this.setState({
                                                stateService: e.target.value
                                            })
                                        }}
                                    >
                                        <option value="">Trạng thái</option>
                                        <option value="PAID">Đã thanh toán</option>
                                        <option value="NEW_REGISTER">Đăng ký mới</option>
                                        <option value="CANCEL">Đã hủy</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="d-flex align-right col-md-12 col-xs-12 row">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2 col-md-12 col-xs-12">
                                <button
                                    style={{minWidth: "fit-content", marginRight: "10px"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.updatePaymentState()}
                                >
                                        <span className='justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    style={{minWidth: "fit-content"}}
                                    type="button"
                                    className="col-md-2 col-xs-2 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className=''>
                                            Hủy
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalDetailPaymentEat